import { useState } from 'react';
import './ToolStyles.css';

const Base64Converter = () => {
    const [input, setInput] = useState('');
    const [output, setOutput] = useState('');
    const [mode, setMode] = useState<'encode' | 'decode'>('encode');
    const [error, setError] = useState('');

    const handleConvert = () => {
        setError('');
        if (!input.trim()) {
            setOutput('');
            return;
        }
        try {
            if (mode === 'encode') {
                const bytes = new TextEncoder().encode(input);
                const binary = String.fromCharCode(...bytes);
                setOutput(btoa(binary));
            } else {
                const binary = atob(input.trim());
                const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
                setOutput(new TextDecoder().decode(bytes));
            }
        } catch {
            setError(mode === 'decode' ? '无效的 Base64 字符串' : '编码失败');
            setOutput('');
        }
    };

    const handleSwap = () => {
        setMode((prev) => (prev === 'encode' ? 'decode' : 'encode'));
        setInput(output);
        setOutput('');
        setError('');
    };

    return (
        <div className="tool-container">
            <div className="button-group">
                <button
                    className={`mode-button ${mode === 'encode' ? 'active' : ''}`}
                    onClick={() => { setMode('encode'); setOutput(''); setError(''); }}
                >
                    编码
                </button>
                <button
                    className={`mode-button ${mode === 'decode' ? 'active' : ''}`}
                    onClick={() => { setMode('decode'); setOutput(''); setError(''); }}
                >
                    解码
                </button>
            </div>

            <div className="input-group">
                <label className="input-label">
                    {mode === 'encode' ? '输入文本' : '输入 Base64'}
                </label>
                <textarea
                    className="tool-textarea"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    rows={5}
                    placeholder={mode === 'encode' ? '输入要编码的文本...' : '输入 Base64 字符串...'}
                />
            </div>

            <div className="button-group">
                <button className="tool-button primary" onClick={handleConvert}>转换</button>
                <button className="tool-button" onClick={handleSwap} disabled={!output && !input}>
                    交换
                </button>
            </div>

            {error && <div className="error-message">{error}</div>}

            {output && (
                <div className="output-group">
                    <div className="output-header">
                        <label className="output-label">结果</label>
                        <button
                            className="copy-button"
                            onClick={() => navigator.clipboard.writeText(output)}
                        >
                            复制
                        </button>
                    </div>
                    <div className="tool-output code">{output}</div>
                </div>
            )}
        </div>
    );
};

export default Base64Converter;
